const SegmentType = {
  AlternativeFill: 'alternative_fill',
  Fill: 'fill',
  Hole: 'hole',
  Untracked: 'untracked',
};

export default SegmentType;
